const products = [
  {
    id: "vpn",
    name: "VPN",
    tagline: "Privacy Without Compromise",
    description:
      "Our iOS VPN app delivers military-grade AES-256 encryption across a global network of secure servers. Designed for seamless performance on iPhone and iPad, it ensures your data stays private — whether on public Wi-Fi or browsing from home.",
    features: [
      "AES-256 Military-Grade Encryption",
      "Global Server Network",
      "Zero-Log Privacy Policy",
      "Automatic Kill Switch",
      "iOS & iPadOS Optimized",
    ],
    icon: "ri-shield-keyhole-fill",
    accent: "from-gray-900 via-gray-800 to-gray-900",
    accentBorder: "border-emerald-500/30",
    image:
      "https://public.readdy.ai/ai/img_res/8d8ce969f3d0b00c2ef1d6175d4e565b.jpg",
    iconBg: "bg-emerald-500/10",
    iconColor: "text-emerald-400",
  },
  {
    id: "cleaner",
    name: "Cleaner",
    tagline: "Speed. Space. Simplicity.",
    description:
      "Our Cleaner app intelligently analyzes your iPhone storage, identifying junk files, duplicate media, and unused caches. Recover gigabytes of space with a single tap and enjoy a faster, more responsive device — all through a beautifully simple iOS interface.",
    features: [
      "Smart Junk File Detection",
      "Duplicate Photo Remover",
      "Cache & Temp File Cleanup",
      "Storage Visualization",
      "Battery Health Insights",
    ],
    icon: "ri-speed-up-fill",
    accent: "from-stone-900 via-stone-800 to-stone-900",
    accentBorder: "border-amber-500/30",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20iPhone%20showing%20a%20device%20cleaner%20optimization%20app%20with%20clean%20white%20minimal%20UI%2C%20storage%20usage%20graph%2C%20progress%20circle%20indicator%2C%20soft%20warm%20ambient%20light%2C%20studio%20product%20photography%2C%20premium%20smartphone%20aesthetic%2C%20isolated%20on%20light%20warm%20gray%20background%2C%20no%20hands&width=500&height=700&seq=cleaner001&orientation=portrait",
    iconBg: "bg-amber-500/10",
    iconColor: "text-amber-400",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-28 bg-gray-50 w-full">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-500 text-sm font-semibold uppercase tracking-widest mb-3 block">
            Our Products
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
            Built for iOS. Built to Last.
          </h2>
          <p className="mt-4 text-gray-500 text-lg max-w-xl mx-auto">
            Two powerful apps engineered exclusively for Apple devices, combining cutting-edge technology with intuitive design.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className={`relative rounded-2xl overflow-hidden border ${product.accentBorder} bg-gradient-to-br ${product.accent} flex flex-col lg:flex-row items-stretch`}
            >
              {/* Image Side */}
              <div className="w-full lg:w-48 h-56 lg:h-auto flex-shrink-0 relative">
                <img
                  src={product.image}
                  alt={`${product.name} iOS app`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-gray-900/40 hidden lg:block" />
              </div>

              {/* Text Side */}
              <div className="flex flex-col justify-between p-8 flex-1">
                {/* Icon + Name */}
                <div>
                  <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${product.iconBg} mb-4`}>
                    <i className={`${product.icon} text-2xl ${product.iconColor}`} />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-1">{product.name}</h3>
                  <p className={`text-sm font-medium mb-4 ${product.iconColor}`}>{product.tagline}</p>
                  <p className="text-gray-400 text-sm leading-relaxed mb-6">{product.description}</p>
                </div>

                {/* Features */}
                <ul className="space-y-2">
                  {product.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-2.5 text-gray-300 text-sm">
                      <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0`}>
                        <i className={`ri-check-line text-base ${product.iconColor}`} />
                      </div>
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
